export default __webpack_public_path__ + "static/media/kinoladder_banner_highlight.36eb6d81.png";